export async function extractPalette(formData) {
  const res = await fetch("https://paletterix-backend.up.railway.app/extract_palette/", {
    method: "POST",
    body: formData,
  });
  if (!res.ok) throw new Error("Failed to extract palette");
  return await res.json(); // { palette: [...] }
}
